<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">服务器</div>
      </div>
      <div class="content-inner-wrapper">
        <img src="../../images/pc/noAny.svg" />
        <p>购买服务器和好朋友一起开启游戏吧～</p>
        <el-button
          @click="$router.push({ name: 'cloudServerBuy' })"
          type="primary"
          >购买服务器</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
img {
  display: block;
  width: 300px;
  height: 219px;
  margin: 60px auto 0;
}
p {
  width: 300px;
  height: 26px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666;
  line-height: 26px;
  text-align: center;
  margin: 10px auto 0;
  text-align: center;
}
.el-button {
  display: block;
  width: 321px;
  height: 54px;
  background: #fecb4e;
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3d3c3c;
  line-height: 20px;
  border-radius: 12px;
  margin: 64px auto 260px;
  border-color: #fecb4e;
}
.container .block .title-wrap {
  border-bottom: none;
}
</style>
